<template>
  <div class="page-wrap">

    <!-- Page header / controls -->
    <div class="panel-card ctrl-panel">
      <div class="panel-header">
        <div class="panel-header__icon"><i class="fa fa-signal"></i></div>
        <div class="panel-header__text">
          <div class="panel-header__title">Analytics</div>
          <div class="panel-header__sub">Appointment trends, location and service breakdowns</div>
        </div>
      </div>

      <div class="ctrl-bar">
        <!-- Period buttons -->
        <div class="period-group">
          <button v-for="(p, i) in periods" :key="i" class="period-btn"
            :class="{ 'period-btn--active': selectedBtn === p.val }" @click="getseriesdata(p.val)">{{ p.label
            }}</button>
        </div>

        <!-- Date range picker -->
        <div class="range-wrap">
          <i class="fa fa-calendar-o range-wrap__icon"></i>
          <date-range-picker ref="picker" v-model="dateRange" :opens="'left'" :ranges="false"
            @update="getseriesdata(5)" />
        </div>
      </div>
    </div>

    <!-- Appointments chart -->
    <div class="panel-card chart-panel">
      <div class="chart-panel__header">
        <div class="chart-panel__icon blue"><i class="fa fa-calendar-check"></i></div>
        <div class="chart-panel__text">
          <div class="chart-panel__title">Appointments</div>
          <div class="chart-panel__sub">Volume over the selected period</div>
        </div>

        <!-- Radio + location filters (non-client only) -->
        <div class="view-toggle" v-if="!currentUser.u.is_client">
          <label class="radio-pill" :class="{ active: app_radio === 'total' }">
            <input type="radio" value="total" v-model="app_radio" @change="getseriesdata(selectedBtn)" />
            Total
          </label>
          <label class="radio-pill" :class="{ active: app_radio === 'loaction' }">
            <input type="radio" value="loaction" v-model="app_radio" @change="getseriesdata(selectedBtn)" />
            By Location
          </label>
        </div>
      </div>

      <!-- Location checkboxes -->
      <div class="loc-filters" v-if="app_radio === 'loaction' && series.length">
        <label v-for="(s, i) in series" :key="i" class="loc-check"
          :class="{ active: selected_location.includes(s.name) }">
          <input type="checkbox" :value="s.name" v-model="selected_location" />
          <span class="loc-dot" :style="{ background: options.colors[i] || '#389ad4' }"></span>
          {{ s.name }}
        </label>
      </div>

      <div class="chart-body">
        <div class="chart-spinner-wrap" v-if="getLoadingData">
          <div class="state-spinner"></div>
          <span>Loading chart…</span>
        </div>
        <chart v-else :key="'app-' + index" :width="app_chart_width" :height="chart_height" :ctype="ctype"
          :options="options" :series="filtered_location" />
      </div>
    </div>

    <!-- Location + Service charts row -->
    <div class="donut-row" v-show="app_radio === 'total'">

      <!-- Location donut (non-client only) -->
      <div class="panel-card chart-panel" v-if="!currentUser.u.is_client">
        <div class="chart-panel__header">
          <div class="chart-panel__icon green"><i class="fa fa-map-marker"></i></div>
          <div class="chart-panel__text">
            <div class="chart-panel__title">By Location</div>
            <div class="chart-panel__sub">Appointment share per location</div>
          </div>
        </div>
        <div class="chart-body">
          <div class="chart-spinner-wrap" v-if="getLoadingData">
            <div class="state-spinner"></div>
            <span>Loading chart…</span>
          </div>
          <chart v-else :key="'loc-' + index" :width="500" :ctype="'donut'" :options="pieLocaionOptions"
            :series="pielocationseries" />
        </div>
      </div>

      <!-- Service donut -->
      <div class="panel-card chart-panel">
        <div class="chart-panel__header">
          <div class="chart-panel__icon orange"><i class="fa fa-briefcase"></i></div>
          <div class="chart-panel__text">
            <div class="chart-panel__title">By Service</div>
            <div class="chart-panel__sub">Popular services breakdown</div>
          </div>
        </div>
        <div class="chart-body">
          <div class="chart-spinner-wrap" v-if="getLoadingData">
            <div class="state-spinner"></div>
            <span>Loading chart…</span>
          </div>
          <chart v-else :key="'svc-' + index" :width="500" :ctype="'donut'" :options="pieOptions" :series="pieseries" />
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import Chart from "@/includes/graph/Chart";
import { mapGetters } from "vuex";
import {
  FETCH_APPOITMENT_DATA_FOR_GRAPH,
  FETCH_APPOITMENT_LOCATION_DATA_FOR_GRAPH,
} from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";

export default {
  components: { DateRangePicker, Chart },
  data() {
    const startDate = this.$moment().format("YYYY/MM/DD");
    const endDate = this.$moment().format("YYYY/MM/DD");
    return {
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Analytics", route: "" },
      ],
      periods: [
        { label: "Week", val: 2 },
        { label: "Month", val: 3 },
        { label: "Year", val: 4 },
      ],
      dateRange: { startDate, endDate },
      options: {
        chart: { animations: { enabled: false }, zoom: { enabled: false } },
        xaxis: { categories: [] },
        stroke: { curve: "straight", width: 3 },
        plotOptions: { bar: { dataLabels: { position: "top" } } },
        colors: [],
      },
      pieseries: [],
      pieOptions: {
        chart: { type: "donut", toolbar: { show: true } },
        labels: [],
        colors: [],
        responsive: [{ breakpoint: 480, options: { chart: { width: 500 }, legend: { position: "top" } } }],
      },
      pielocationseries: [],
      pieLocaionOptions: {
        chart: { type: "donut", toolbar: { show: true } },
        labels: [],
        colors: [],
        responsive: [{ breakpoint: 480, options: { chart: { width: 800 }, legend: { position: "bottom", horizontalAlign: "right" } } }],
      },
      series: [],
      selectedBtn: 2,
      app_radio: "total",
      selected_location: [],
      index: 0,
      ctype: "bar",
      getLoadingData: false,
      chart_height: 400,
      app_chart_width: 600,
    };
  },
  computed: {
    ...mapGetters(["currentUser", "getDashboardcardDate"]),
    filtered_location() {
      if (this.app_radio === "total") return this.series;
      return this.series.filter(loc => this.selected_location.includes(loc.name));
    },
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.app_chart_width = this.currentUser.u.is_client ? 900 : 600;
    this.getseriesdata();
  },
  methods: {
    setdate(val) {
      let startDate = new Date();
      let endDate = new Date();
      switch (val) {
        case 1:
          this.dateRange = { startDate, endDate };
          break;
        case 2:
          startDate = this.$moment().startOf("isoWeek");
          endDate = this.$moment().endOf("isoWeek");
          this.dateRange = { startDate, endDate };
          break;
        case 3:
          startDate = this.$moment().startOf("month");
          endDate = this.$moment().endOf("month");
          this.dateRange = { startDate, endDate };
          break;
        case 4:
          startDate = this.$moment().startOf("year");
          endDate = this.$moment().endOf("year");
          this.dateRange = { startDate, endDate };
          break;
      }
    },
    getseriesdata(val = 2) {
      this.selectedBtn = val;
      this.getLoadingData = true;
      this.setdate(val);
      const data = {
        daterange: this.dateRange,
        type: val,
        client: this.currentUser.u.is_client ? "c" : "sp",
        app_type: this.app_radio,
      };
      if (this.app_radio === "total") {
        this.ctype = "bar";
        this.chart_height = 400;
        this.options.xaxis.categories = [];
        this.options.colors = ["#389ad4"];
        this.$store.dispatch(FETCH_APPOITMENT_DATA_FOR_GRAPH, data)
          .then(res => {
            this.options.xaxis.categories = res.detail.date;
            this.series = [{ name: "Total", data: res.detail.count }];
            this.pieOptions.colors = res.popular_services.service_colors;
            this.pieOptions.labels = res.popular_services.name;
            this.pieseries = res.popular_services.values;
            if (!this.currentUser.u.is_client) {
              this.pieLocaionOptions.colors = res.popular_locations.location_colors;
              this.pieLocaionOptions.labels = res.popular_locations.name;
              this.pielocationseries = res.popular_locations.values;
            }
            this.getLoadingData = false;
            this.index += 1;
          })
          .catch(e => { this.$toastr.e(e); this.getLoadingData = false; });
      } else {
        this.options.xaxis.categories = [];
        this.ctype = val === 1 ? "bar" : "line";
        this.chart_height = 600;
        this.$store.dispatch(FETCH_APPOITMENT_LOCATION_DATA_FOR_GRAPH, data)
          .then(res => {
            this.options.xaxis.categories = res.date;
            this.options.colors = res.location_colors;
            this.series = res.detail;
            this.selected_location = res.detail.map(e => e.name);
            this.getLoadingData = false;
            this.index += 1;
          })
          .catch(() => { this.$toastr.e("oops! something went wrong"); this.getLoadingData = false; });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;
$green: #276749;
$orange: #e07b2a;

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.page-wrap {
  padding: 12px;
  padding-bottom: 100px;
  font-family: $font;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── panel card ── */
.panel-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 16px;
  overflow: clip;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

/* ── panel header ── */
.panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    flex-shrink: 0;
  }

  &__text {
    flex: 1;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: $dark;
    line-height: 1.2;
  }

  &__sub {
    font-size: 12px;
    color: #7a8499;
    margin-top: 3px;
  }
}

/* ── controls bar ── */
.ctrl-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 24px;
  flex-wrap: wrap;
}

.period-group {
  display: inline-flex;
  border: 1.5px solid $border;
  border-radius: 9px;
  overflow: hidden;
}

.period-btn {
  padding: 7px 18px;
  border: none;
  background: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  color: #5a6278;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  border-right: 1px solid $border;

  &:last-child {
    border-right: none;
  }

  &:hover {
    background: #f4f6fb;
  }

  &--active {
    background: $blue;
    color: #fff;

    &:hover {
      background: #2d85bb;
    }
  }
}

.range-wrap {
  position: relative;
  display: flex;
  align-items: center;

  &__icon {
    position: absolute;
    left: 11px;
    color: #a0aab8;
    font-size: 13px;
    z-index: 1;
    pointer-events: none;
  }

  ::v-deep .vue-daterange-picker {
    margin: 0;

    .reportrange-text {
      height: 36px;
      border: 1.5px solid $border;
      border-radius: 8px;
      font-size: 13px;
      font-family: $font;
      color: $dark;
      padding: 0 12px 0 32px;
      display: flex;
      align-items: center;
      cursor: pointer;
      background: #fff;
      transition: border-color 0.2s;

      &:hover {
        border-color: $blue;
      }
    }
  }
}

/* ── chart panel header ── */
.chart-panel__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid $border;
  background: #fafbff;
}

.chart-panel__icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 15px;
  flex-shrink: 0;

  &.blue {
    background: linear-gradient(135deg, $blue, #2277aa);
  }

  &.green {
    background: linear-gradient(135deg, #34a06b, #276749);
  }

  &.orange {
    background: linear-gradient(135deg, $orange, #b85c10);
  }
}

.chart-panel__text {
  flex: 1;
}

.chart-panel__title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
}

.chart-panel__sub {
  font-size: 12px;
  color: #7a8499;
  margin-top: 2px;
}

/* ── view toggle (radio pills) ── */
.view-toggle {
  display: inline-flex;
  border: 1.5px solid $border;
  border-radius: 8px;
  overflow: hidden;
}

.radio-pill {
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 600;
  font-family: $font;
  color: #5a6278;
  cursor: pointer;
  border-right: 1px solid $border;
  transition: background 0.15s, color 0.15s;
  user-select: none;

  input {
    display: none;
  }

  &:last-child {
    border-right: none;
  }

  &:hover {
    background: #f4f6fb;
  }

  &.active {
    background: $blue;
    color: #fff;
  }
}

/* ── location checkboxes ── */
.loc-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid $border;
  background: #fafbff;
}

.loc-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1.5px solid $border;
  font-size: 12px;
  font-weight: 500;
  color: $dark;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  user-select: none;

  input {
    display: none;
  }

  &.active {
    border-color: transparent;
    background: rgba(56, 154, 212, 0.08);
  }
}

.loc-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ── chart body ── */
.chart-body {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.chart-spinner-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #7a8499;
  font-size: 13px;
  padding: 40px;
}

.state-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #c5d8f5;
  border-top-color: $blue;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  margin-bottom: 4px;
}

/* ── donut row ── */
.donut-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
}
</style>
